import { TS_OfferMoreFlight } from "../TravelSeller/Models/TS_OfferMoreFlight";
import { BookingItemInterface } from "./BookingItemInterface";

export class OfferMoreFlight extends TS_OfferMoreFlight implements BookingItemInterface {}
